exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-order-package-tracking-modal :first-of-type(.modal-container) {\n  max-width: 800px;\n  width: auto;\n}\n.add-order-package-tracking-modal .list-group-item-subcustomer-name {\n  flex-grow: 1;\n  margin-left: 9px;\n}", ""]);

// exports
